import { ReportComponent } from './report.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxLoadIndicatorModule, DxLoadPanelModule, DxPopupModule, DxProgressBarModule } from 'devextreme-angular';
import { ReportService } from './report.service';
import { DxReportViewerModule } from 'devexpress-reporting-angular';
import { ReportRoutingModule } from './report-routing.module';
import { LoadReportComponent } from './load-report/load-report.component';
import { NbCardModule, NbLayoutModule, NbSpinnerModule, NbAlertModule } from '@nebular/theme';
import { ThemeModule } from '../@theme/theme.module';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ReportViewerPdfComponent } from './report-viewer-pdf/report-viewer-pdf.component';
import { LocalizationModule } from '../@core/localization/localization.module';


@NgModule({
  imports: [
    CommonModule,
    DxLoadPanelModule,
    DxReportViewerModule,
    DxPopupModule,
    ReportRoutingModule,
    ThemeModule,
    NbLayoutModule,
    NbCardModule,
    NbSpinnerModule,
    NbAlertModule,
    NgxExtendedPdfViewerModule,
    DxButtonModule,
    DxProgressBarModule,
    DxLoadIndicatorModule,
    LocalizationModule
  ],
  declarations: [LoadReportComponent, ReportComponent, ReportViewerPdfComponent],
  exports: [DxLoadPanelModule, DxPopupModule, DxReportViewerModule, ReportViewerPdfComponent],
  providers: [ReportService]
})
export class ReportModule { }
